import { clear as idbClear } from 'idb-keyval';

let clearing = false;

export const isClearing = () => clearing;

export const clear = async () => {
  // Prevent parallel clear calls
  if (clearing) return;
  clearing = true;

  try {
    await idbClear();
  } catch (error) {
    console.error('Could not clear indexed db', { error });
  } finally {
    clearing = false;
  }
};
